import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { logout, selectToken } from "../features/auth/authSlice";

const baseQuery = fetchBaseQuery({
  baseUrl: "https://dl.techrih.com",
  // baseUrl: "http://localhost:5001",

  prepareHeaders: (headers, { getState }) => {
    const token = selectToken(getState());
    if (token) headers.set("authorization", `Bearer ${token}`);
    return headers;
  },
  credentials: "include", // in case you later switch to httpOnly cookies
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);
  if (result?.error?.status === 401) {
    api.dispatch(logout());
  }
  return result;
};

export const api = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Machine", "Admin"],
  endpoints: () => ({}),
});
